import styles from './style.module.scss';
import { BACKGROUNDS } from '@/styles/constants';
import { clsName } from '@/utils/helpers';
import type { Section } from '@/types/components/section';

const Section = ({
  children,
  fullSize,
  background = 'transparent',
  renderAs = 'section',
  mobileFullSize,
  noMaxWidth,
  classNameCommon,
}: Section) => {
  const className = clsName(
    styles.Section,
    BACKGROUNDS[background],
    fullSize && styles.Section_fullSize,
    mobileFullSize && styles.Section_mobileFullSize,
    noMaxWidth && styles.Section_noMaxWidth,
    classNameCommon,
  );

  const Component = renderAs;

  return (
    <Component className={className}>
      <div className={styles.Frame}>
        <div className={styles.Content}>{children}</div>
      </div>
    </Component>
  );
};

export default Section;
